import { gql } from "@apollo/client";export default gql`mutation UpdateGroupCollection($id: Int = 10, $order: Int = 10) {
    update_group_collection_by_pk(
        pk_columns: { id: $id }
        _set: { order: $order }
    ) {
        id
    }
}
`;
